import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Link } from "react-router-dom";
import { Globe, Heart, Users } from "lucide-react";
import { motion } from "framer-motion";

const StatsSection = () => {
  return (
    <section className="py-8">
      <div className="container mx-auto px-4">
        <motion.div
          className="text-center mb-12"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4">Our Impact Across United States of America</h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            "Inspired by the words of Apostle Paul regarding King David in Acts 13:36, let's wholeheartedly serve our
            Lord and Savior Jesus Christ in this generation."
          </p>
          <p className="text-sm text-muted-foreground mt-2 font-semibold">- Israel Nandamudi, President OFUESI</p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            <Card className="divine-card h-full hover:shadow-lg transition-all duration-300">
              <CardContent className="p-6 text-center bg-gradient-to-br from-emerald-50 to-cyan-50 h-full min-h-[220px] flex flex-col justify-center">
                <motion.div
                  className="w-16 h-16 mx-auto mb-4 bg-gradient-to-br from-emerald-500 to-cyan-500 rounded-full flex items-center justify-center shadow-lg"
                  whileHover={{ scale: 1.1, rotate: 10 }}
                  transition={{ type: "spring", stiffness: 300 }}
                >
                  <Globe className="w-8 h-8 text-white" />
                </motion.div>
                <h3 className="text-3xl font-bold text-emerald-600">6 Regions</h3>
                <p className="text-slate-600">Across the United States</p>
              </CardContent>
            </Card>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            <Card className="divine-card h-full hover:shadow-lg transition-all duration-300">
              <CardContent className="p-6 text-center bg-gradient-to-br from-purple-50 to-rose-50 h-full min-h-[220px] flex flex-col justify-center">
                <motion.div
                  className="w-16 h-16 mx-auto mb-4 bg-gradient-to-br from-purple-500 to-rose-500 rounded-full flex items-center justify-center shadow-lg"
                  whileHover={{ scale: 1.1, rotate: 10 }}
                  transition={{ type: "spring", stiffness: 300 }}
                >
                  <Users className="w-8 h-8 text-white" />
                </motion.div>
                <h3 className="text-3xl font-bold text-purple-600">1.1M Students</h3>
                <p className="text-slate-600">International students in US</p>
              </CardContent>
            </Card>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            <Card className="divine-card h-full hover:shadow-lg transition-all duration-300">
              <CardContent className="p-6 text-center bg-gradient-to-br from-amber-50 to-orange-50 h-full min-h-[220px] flex flex-col justify-center">
                <motion.div
                  className="w-16 h-16 mx-auto mb-4 bg-gradient-to-br from-amber-500 to-orange-500 rounded-full flex items-center justify-center shadow-lg"
                  whileHover={{ scale: 1.1, rotate: 10 }}
                  transition={{ type: "spring", stiffness: 300 }}
                >
                  <Heart className="w-8 h-8 text-white" />
                </motion.div>
                <h3 className="text-3xl font-bold text-amber-600">4,000+</h3>
                <p className="text-slate-600">Universities & Colleges</p>
              </CardContent>
            </Card>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            <Card className="divine-card h-full hover:shadow-lg transition-all duration-300">
              <CardContent className="p-6 text-center bg-gradient-to-br from-purple-50 to-rose-50 h-full min-h-[220px] flex flex-col justify-center">
                <h3 className="text-xl font-bold text-blue-600">New to the US?</h3>
                <p className="text-muted-foreground mb-4 text-sm">
                  Connect with fellow students and find your spiritual home away from home.
                </p>
                <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
                  <Button
                    asChild
                    className="w-full border-white text-white hover:bg-white hover:text-primary hover:border-primary hover:border-2 shadow-divine"
                  >
                    <Link to="/new-students">Get Connected</Link>
                  </Button>
                </motion.div>
              </CardContent>
            </Card>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
